/**
 * Haptic Feedback Service
 *
 * Provides haptic feedback (vibration) for mobile devices.
 * Gracefully degrades for non-compatible devices.
 */

export type HapticPattern = "light" | "medium" | "strong";

interface HapticConfig {
  duration: number; // milliseconds
  pattern: number[]; // vibration pattern [vibrate, pause, vibrate, ...]
}

const patterns: Record<HapticPattern, HapticConfig> = {
  light: { duration: 10, pattern: [10] },
  medium: { duration: 30, pattern: [20, 10, 20] },
  strong: { duration: 50, pattern: [30, 15, 30, 15, 30] },
};

export class HapticFeedbackService {
  static isSupported(): boolean {
    return "vibrate" in navigator;
  }

  static trigger(pattern: HapticPattern = "medium"): void {
    if (!this.isSupported()) {
      return; // Silently fail on non-compatible devices
    }

    const config = patterns[pattern];
    try {
      navigator.vibrate(config.pattern);
    } catch (error) {
      console.debug("Haptic feedback error:", error);
    }
  }

  static success(): void {
    this.trigger("medium");
  }

  static error(): void {
    this.trigger("strong");
  }

  static notification(): void {
    this.trigger("light");
  }
}
